import * as firebase from '../'

const storageRef = firebase.storage().ref();

const profileRef = storageRef.child('Profiles/');
const storyRef = storageRef.child('Story/');

const getPhotoRef = (category) => {
    switch (category) {
        case 'profile':
            return profileRef;
        case 'story':
            return storyRef;
        default:
            return null;
    }
};

const uploadPhoto =  async (category, photoFile, photoFilename) => {
    const photoRef = getPhotoRef(category);
    if (photoRef === null || photoFile === null) return null;
    try {
        const snapshot = await photoRef.child(`${photoFilename}`).put(photoFile);
        return await snapshot.ref.getDownloadURL();
    } catch (e) {
        console.log('Upload error, ' + e.message);
        return null;
    }
};

export {
    uploadPhoto
}
